import {
  PaymentApproveActionTypes,
  PAYMENT_APPROVE_FAIL,
  PAYMENT_APPROVE_LOADING,
  PAYMENT_APPROVE_SUCCESS,
  paymentApproveState,
  PAYMENT_APPROVE_API_MSG,
  PAYMENT_APPROVE_API_RES,
} from "./ActionTypes";
import { PaymentApproveDetailsResponse } from "./Model";

const initialStateEditPosts: paymentApproveState = {
  loading: false,
  paymentApproveResponse: {} as PaymentApproveDetailsResponse,
  successMsg: "",
  errorMsg: "",
  status: 0,
};
export const paymentApproveValueReducer = (
  state = initialStateEditPosts,
  action: PaymentApproveActionTypes
): paymentApproveState => {
  switch (action.type) {
    case PAYMENT_APPROVE_LOADING:
      return {
        ...state,
        loading: action.loading,
      };
    case PAYMENT_APPROVE_SUCCESS:
      return {
        ...state,
        paymentApproveResponse: action.payload,
        successMsg: action.successMsg,
      };
    case PAYMENT_APPROVE_FAIL:
      return {
        ...state,
        paymentApproveResponse: action.payload,
        errorMsg: action.errorMsg,
        status: action.status,
      };
    case PAYMENT_APPROVE_API_MSG:
      return {
        ...state,
        paymentApproveResponse: action.payload,
        successMsg: action.successMsg,
        errorMsg: action.errorMsg,
        status: action.status,
      };
    case PAYMENT_APPROVE_API_RES:
      return {
        ...state,
        paymentApproveResponse: action.payload,
        successMsg: action.successMsg,
        errorMsg: action.errorMsg,
        status: action.status,
      };
    default:
      return state;
  }
};
